import { render } from "./Hall.vue?vue&type=template&id=5e567dd7&ts=true"
import script from "./Hall.vue?vue&type=script&lang=ts"
export * from "./Hall.vue?vue&type=script&lang=ts"

import "./Hall.vue?vue&type=style&index=0&id=5e567dd7&lang=scss"

import exportComponent from "D:\\封面新闻\\activity\\ssccloudtour\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__